/* eslint-disable max-len */

import enTranslations from '@/assets/locales/en.json'; // English
import ruTranslations from '@/assets/locales/ru.json'; // Russian
import plTranslations from '@/assets/locales/pl.json'; // Polish
import deTranslations from '@/assets/locales/de.json'; // German
import esTranslations from '@/assets/locales/es.json'; // Spanish
import frTranslations from '@/assets/locales/fr.json'; // French
import itTranslations from '@/assets/locales/it.json'; // Italian
export const SUPPPORTED_LOCALES = ['en', 'ru', 'pl', 'de', 'es', 'fr', 'it'];
export const TEXT_DICTIONARY = {
    en: enTranslations,
    ru: ruTranslations,
    pl: plTranslations,
    de: deTranslations,
    es: esTranslations,
    fr: frTranslations,
    it: itTranslations,
};
